(() => {
  const initPowerbankGrid = (section) => {
    if (!section || section.dataset.powerbankGridReady === 'true') return;

    const track = section.querySelector('[data-powerbank-track]');
    const nextButton = section.querySelector('[data-powerbank-next]');

    if (!track || !nextButton) return;

    section.dataset.powerbankGridReady = 'true';

    const getStep = () => {
      const firstCard = track.querySelector('.sm-powerbank-card');
      if (!firstCard) return track.clientWidth * 0.8;

      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0');

      return firstCard.getBoundingClientRect().width + gap;
    };

    const updateButton = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      nextButton.hidden = maxScroll <= 2;
    };

    nextButton.addEventListener('click', () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const nearEnd = track.scrollLeft >= maxScroll - 8;

      track.scrollTo({
        left: nearEnd ? 0 : Math.min(track.scrollLeft + getStep(), maxScroll),
        behavior: 'smooth'
      });
    });

    updateButton();

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateButton);
      observer.observe(track);
    } else {
      window.addEventListener('resize', updateButton);
    }
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-powerbank-grid]').forEach(initPowerbankGrid);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
